import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { SharedModule } from 'src/app/shared/shared.module';

export enum EditorExitAction {
  Stay = 'stay',
  Discard = 'discard',
  Save = 'save'
}

@Component({
    standalone: true,
    selector: 'app-editor-exit-dialog',
    imports: [SharedModule],
    templateUrl: './editor-exit-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./editor-exit-dialog.component.scss']
})
export class EditorExitDialogComponent {
  constructor(private dialogRef: MatDialogRef<EditorExitDialogComponent>) {}

  stay(): void { this.dialogRef.close(EditorExitAction.Stay); }
  discard(): void { this.dialogRef.close(EditorExitAction.Discard); }
  save(): void { this.dialogRef.close(EditorExitAction.Save); }
}
